const registry = {};

const pluginSlots = {
  register(slotName, component) {
    if (!registry[slotName]) {
      registry[slotName] = [];
    }

    registry[slotName].push(component);
  },
  get(slotName) {
    return registry[slotName] || [];
  },
  has(slotName) {
    return !!(registry[slotName] && registry[slotName].length);
  },
  list() {
    return Object.keys(registry);
  },
};

export default pluginSlots;
